const guardianFullname = (guardian, includeSalutation = true) => {
  if (!guardian) return null

  if (includeSalutation) {
    return `${guardian.salutation || ""} ${guardian.forename || ""} ${guardian.surname || ""}`.replace(/  +/g, " ").trim()
  }

  return `${guardian.forename || ""} ${guardian.surname || ""}`.replace(/  +/g, " ").trim()
}

export default guardianFullname
